export default __webpack_public_path__ + "static/media/AntyLucy_18.4d9fc2bf.jpg";